// MobileSearchBar.jsx
import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import ContactForm from "@/components/form/ContactForm";
import ButtonPrime from "./ButtonPrime";
import { FileChartColumnIncreasingIcon } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";
import { Button } from "@/components/ui/button";
import { IconPhoneCall } from "@tabler/icons-react";

const MobileBar = ({
  info,
  contactFormFields,
  contactFormButton,
  merkmal,
  immobilie,
}) => {
  // State to control the bar visibility
  const [show, setShow] = useState(true);
  // Using a ref to store the last scroll Y position
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // If scrolling up (current scroll is less than last), hide the search bar.
      // Otherwise (scrolling down), show it.
      if (currentScrollY < lastScrollY.current) {
        setShow(false);
      } else {
        setShow(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Framer Motion variants for smooth in/out animations
  const variants = {
    hidden: { y: 100, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <motion.div
      initial="visible"
      animate={show ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 0.3 }}
      className="fixed bottom-0 left-0 right-0 h-[5rem] bg-prime-200/70 backdrop-blur-sm my-2 rounded-lg mx-2 shadow-xl p-4 flex items-center   space-x-4 z-50 lg:hidden"
    >
      {/* Expose Anfragen Modal Trigger */}
      <Dialog>
        <DialogTrigger >
          <ButtonPrime className=" h-[3rem]"><FileChartColumnIncreasingIcon className="inline-block mr-2]"/> Expose anfragen</ButtonPrime> 
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Expose anfragen</DialogTitle>
            <DialogDescription>
              <ContactForm
                fields={
                  contactFormFields ||
                  ["name", "email", "phone", "address", "agbAccepted", "message"]
                }
                button={contactFormButton || "Expose anfragen"}
                merkmal={merkmal}
                immobilie={immobilie}
              />
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
      <Popover>
        <PopoverTrigger asChild>
        <img className="size-[3.5rem] border-2 border-prime-300 rounded-full" src={immobilie.broker?.avatar} alt="" />

        </PopoverTrigger>
        <PopoverContent className="w-72 p-4 space-y-5 bg-prime-50">
          <div className="flex flex-col items-start justify-center gap-2">
            <BeratungsterminModal trigger={<Button className="w-full">Beratungstermin buchen</Button>} />
            <p><a className="text-prime-950" href="tel:02403 883170"><IconPhoneCall className="inline mr-2 stroke-[1px]" /> 02403 883170</a></p>
          </div>
        </PopoverContent>
      </Popover>
    </motion.div>
  );
};

export default MobileBar;
